module.exports = __webpack_public_path__ + "static/de_ch.manifest.6443b060.webmanifest";